import styled from"@emotion/styled";import{mediaQuery,Modal,Table}from"@wp/src/components/common";export const Description=styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;

  color: ${props=>props.theme.colors.neutral500};
`;export const TableContainer=styled.div`
  width: 100%;
`;export const DemoPortfolioTable=Table;export const DemoPortfolioTableColumnTitle=styled.span`
  font-weight: 500;
  line-height: 20px;

  color: ${props=>props.theme.colors.neutral600};

  ${mediaQuery({fontSize:["14px","14px","16px"]})}
`;export const DemoPortfolioSetupPopup=styled(Modal)`
  ${props=>!props.centered&&"top: 0;"}

  .ant-modal-content {
    padding: 16px;
  }

  .ant-modal-body {
    padding: 8px 0;
  }
`;